import { ObjectBadgeMapper } from '@frontend/components/common';
import { TransactionState, TransactionStateName } from '@frontend/transaction/types';
import React from 'react';
import { LuX } from 'react-icons/lu';

export interface FilterBadgeProps {
    filterKey: string;
    filterValue: string;
    onRemove: () => void;
}

export const FilterBadge = ({ filterKey, filterValue, onRemove }: FilterBadgeProps) => {
    const renderContent = () => {
        if (filterKey.endsWith('_id')) {
            return (
                <ObjectBadgeMapper
                    type={filterKey}
                    id={filterValue}
                    className='text-foreground-default justify-start text-center text-sm font-semibold'
                />
            );
        }
        if (filterKey === 'state') {
            const state = TransactionState.getByValue(filterValue as TransactionStateName);
            return <span>{state?.displayName || filterValue.replace(/_/g, ' ')}</span>;
        }
        return <span>{filterValue.replace(/_/g, ' ')}</span>;
    };

    return (
        <div className='bg-background-surface border-border-default inline-flex items-center justify-start gap-2 rounded-full border px-3 py-2'>
            <div className='text-foreground-default justify-start text-center text-sm font-semibold'>{renderContent()}</div>
            <LuX
                className='size-4.5'
                onClick={onRemove}
            />
        </div>
    );
};
